import React from "react";
import PageShell from "../components/PageShell";

function DatenschutzPage() {
  return (
    <PageShell maxWidth="max-w-3xl">
        <section className="rounded-2xl border border-[#dce8c8] bg-white p-6 shadow-sm sm:p-8">
          <p className="mb-3 text-xs font-medium uppercase tracking-[0.22em] text-neutral-500">Rechtliches</p>
          <h1 className="text-3xl font-semibold tracking-[-0.04em]">Datenschutzerklärung</h1>

          <div className="mt-8 space-y-6 text-sm leading-7 text-neutral-700">
            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">1. Verantwortliche Person</h2>
              <p>
                Verantwortlich für diese privat betriebene Webseite ist:<br />
                Jan Peters<br />
                Rönneter 205<br />
                41068 Mönchengladbach<br />
                Deutschland<br />
                E-Mail: kontakt@jape-dev.de
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">2. Hinweis zur Schule</h2>
              <p>
                Diese Webseite ist ein privates Schülerprojekt. Sie wird nicht von einer Schule, einem Schulträger oder
                einer kirchlichen Stelle betrieben. Die Schule ist nicht Anbieterin dieser Webseite und nicht
                verantwortlich für die Datenverarbeitung auf dieser Webseite.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">3. Zweck der Webseite</h2>
              <p>
                Diese Webseite dient der Organisation von Mitbringlisten, zum Beispiel für ein KlasseFrühstück, Grillen,
                Waffelessen oder ähnliche Veranstaltungen. Eine Person kann eine Liste erstellen und andere Personen
                können sich mit einem Namen oder Kurznamen für einzelne Einträge eintragen.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">4. Verarbeitete Daten</h2>
              <p>Bei der Nutzung der Webseite können folgende Daten verarbeitet werden:</p>
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li>Listenname</li>
                <li>Mitbring-Einträge und gewünschte Anzahl</li>
                <li>Name oder Kurzname der eintragenden Person</li>
                <li>ausgewählter Eintrag und gewählte Menge</li>
                <li>IDs eigener Einträge und der zuletzt eingegebene Name in der Browser-Session</li>
                <li>Erstellungszeitpunkt der Liste</li>
                <li>technische Zugriffsdaten, zum Beispiel IP-Adresse, Datum, Uhrzeit und aufgerufene Adresse</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">5. Rechtsgrundlage</h2>
              <p>
                Die Verarbeitung erfolgt, soweit sie für die Bereitstellung und Nutzung der Mitbringlisten erforderlich
                ist, auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse liegt in der einfachen
                Organisation gemeinsamer Veranstaltungen und im sicheren Betrieb der Webseite. Soweit eine Einwilligung
                eingeholt wird, erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">6. Speicherung und Löschung</h2>
              <p>
                Die Listen werden nur so lange gespeichert, wie sie für die Organisation der jeweiligen Veranstaltung
                benötigt werden. Listen können über den Lehrerlink bzw. Verwaltungslink gelöscht werden. Nach dem Löschen
                werden die zugehörigen Einträge aus der Datenbank entfernt.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">7. Sichtbarkeit der Einträge</h2>
              <p>
                Die eingetragenen Namen oder Kurznamen sind für Personen sichtbar, die den jeweiligen Listenlink besitzen.
                Deshalb sollten keine vollständigen Namen oder sensiblen Angaben eingetragen werden, wenn dies nicht nötig
                ist.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">8. Weitergabe von Daten</h2>
              <p>
                Eine Weitergabe der eingegebenen Daten an Dritte findet nicht statt, außer sie ist für den technischen
                Betrieb der Webseite erforderlich oder gesetzlich vorgeschrieben. Für die Bereitstellung des Frontends
                wird der Hosting-Anbieter Skrime eingesetzt.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">9. Hosting und Server-Logfiles</h2>
              <p>
                Das Frontend dieser Webseite wird bei Skrime gehostet. Das Backend wird privat auf einem eigenen Server
                betrieben. Beim Aufruf der Webseite und bei der Nutzung der Mitbringlisten können technische Zugriffsdaten
                verarbeitet werden, zum Beispiel IP-Adresse, Datum und Uhrzeit des Zugriffs, Browserinformationen,
                aufgerufene Adressen sowie API- und WebSocket-Anfragen. Diese Daten dienen dem sicheren und stabilen
                Betrieb der Webseite und des Backends.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">10. Cookies und lokale Speicherung</h2>
              <p>
                Diese Webseite setzt nach aktuellem Stand keine eigenen Cookies und verwendet keine lokale Speicherung im
                Browser für Tracking-Zwecke. Für Komfortfunktionen wird lokale Browserspeicherung genutzt: Das gewählte
                Farbschema wird im Local Storage gespeichert. Außerdem speichert die Schüleransicht in der Session Storage
                des Browsers den zuletzt eingegebenen Namen und die IDs der eigenen Einträge zur jeweiligen Liste. Dadurch
                können Schülerinnen und Schüler nach einem versehentlichen Schließen der Webseite ihre eigenen Einträge
                wiedererkennen und sich austragen. Diese Session-Daten bleiben nur im jeweiligen Browser gespeichert und
                werden nicht für Tracking verwendet.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">11. Live-Aktualisierung</h2>
              <p>
                Für die automatische Aktualisierung von Listen kann eine WebSocket-Verbindung zum Server aufgebaut
                werden. Dabei wird die jeweilige Listen-ID übertragen, damit Änderungen der richtigen Liste angezeigt
                werden können.
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">12. Rechte betroffener Personen</h2>
              <p>Betroffene Personen haben nach der DSGVO insbesondere folgende Rechte:</p>
              <ul className="mt-2 list-disc space-y-1 pl-5">
                <li>Auskunft über gespeicherte personenbezogene Daten gemäß Art. 15 DSGVO</li>
                <li>Berichtigung unrichtiger Daten gemäß Art. 16 DSGVO</li>
                <li>Löschung von Daten gemäß Art. 17 DSGVO</li>
                <li>Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</li>
                <li>Datenübertragbarkeit gemäß Art. 20 DSGVO, soweit anwendbar</li>
                <li>Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO</li>
                <li>Widerruf einer Einwilligung mit Wirkung für die Zukunft gemäß Art. 7 Abs. 3 DSGVO</li>
              </ul>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">13. Beschwerderecht</h2>
              <p>
                Betroffene Personen haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn sie
                der Ansicht sind, dass die Verarbeitung ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt.
                Zuständig ist in der Regel die Landesbeauftragte für Datenschutz und Informationsfreiheit
                Nordrhein-Westfalen.
              </p>
              <p className="mt-2">
                Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen<br />
                Website: www.ldi.nrw.de<br />
                E-Mail: poststelle@ldi.nrw.de
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">14. Stand</h2>
              <p>
                Stand: Juni 2026.
              </p>
            </section>
          </div>
        </section>
    </PageShell>
  );
}

export default DatenschutzPage;
